import React from 'react';
import Maps from './MapComponent';
import './Map.css';

const Map = () => {

  const locations = [
    { name: 'QATAR', latitude: 25.3548, longitude: 51.1839 },
    { name: 'UAE', latitude: 23.4241, longitude: 53.8478 },
    { name: 'BAHRAIN', latitude: 26.0667, longitude: 50.5577 },
    { name: 'MOHALI', latitude: 30.7046, longitude: 76.7179 },
    { name: 'CHENNAI', latitude: 13.0843, longitude: 80.2705 },
  ];

  return (
    <section className='map-sec'>
      <Maps locations={locations} />
    </section>
  );
};

export default Map;
